import React from 'react';
import { AdminListWrapper, TableCell } from 'components/Hospital/PaginationForms';
import moment from 'moment';
import { adminVoucherListWidth } from 'constants/pagination';
import { Body3Medium } from 'styles/Global/typography';
import styled from 'styled-components';
import { PrimaryColor, WarningColor, TextColor } from 'styles/Global/colorSemantic';
import { AdminVoucherPaginationTableProps } from 'models/Admin/AdminVoucherPageTypes';
import { getWidthRation } from 'utils/calculateWdith';

const AdminVoucherPaginationTable = ({ currentData, totalCount, currentPage, clickSmsSendButton }: AdminVoucherPaginationTableProps) => {
    const itemsPerPage = 11;

    const getStatusText = (status: number) => {
        switch (status) {
            case 0:
                return '미사용';
            case 1:
                return '사용';
            case 2:
                return '만료';
            default:
                return '-';
        }
    };

    const getStatusColor = (status: number) => {
        switch (status) {
            case 0:
            case 1:
                return PrimaryColor.color_primary_normal;
            case 2:
                return WarningColor.color_warning_normal;
            default:
                return TextColor.color_text_weak;
        }
    };

    const getTypeText = (type: number) => {
        switch (type) {
            case 0:
                return '성남시';
            case 1:
                return '상용';
            case 2:
                return '테스트';
            case 3:
                return '컨시어지';
            case 4:
                return 'AI';
            default:
                return '-';
        }
    };

    const getTypeColor = (type: number) => {
        switch (type) {
            case 0:
            case 1:
            case 3:
            case 4:
                return PrimaryColor.color_primary_normal;
            case 2:
                return WarningColor.color_warning_normal;
            default:
                return TextColor.color_text_weak;
        }
    };

    return (
        <>
            {currentData?.map((item, idx) => {
                const registrationDate = moment(item.timestamp).format('YYYY.MM.DD HH:mm:ss');
                const itemNumber = totalCount - (currentPage - 1) * itemsPerPage - idx;

                return (
                    <AdminListWrapper key={idx}>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[0])} $type='no'>
                            {itemNumber}
                        </TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[1])}>{registrationDate}</TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[2])}>{item.code}</TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[3])}>
                            <StatusBadge $color={getStatusColor(item.status)}>{getStatusText(item.status)}</StatusBadge>
                        </TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[4])}>
                            <TypeBadge $color={getTypeColor(item.type)}>{getTypeText(item.type)}</TypeBadge>
                        </TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[5])}>{item.usedTimestamp ? moment(item.usedTimestamp).format('YYYY.MM.DD HH:mm:ss') : '-'}</TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[6])}>{item.expiredTimestamp ? moment(item.expiredTimestamp).format('YYYY.MM.DD HH:mm:ss') : '-'}</TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[7])}>{item.sendTimestamp ? moment(item.sendTimestamp).format('YYYY.MM.DD HH:mm:ss') : '-'}</TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[8])}>{item.description ?? '-'}</TableCell>
                        <TableCell $width={getWidthRation(adminVoucherListWidth[9])}>
                            <ButtonContainer>
                                <SmsButton onClick={() => clickSmsSendButton(item)} disabled={item.status !== 0 || item.expiredTimestamp < Date.now()}>
                                    SMS 전송
                                </SmsButton>
                            </ButtonContainer>
                        </TableCell>
                    </AdminListWrapper>
                );
            })}
        </>
    );
};

const StatusBadge = styled(Body3Medium)<{ $color: string }>`
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 0px;
    border-radius: 9999px;
    background: rgba(0, 192, 218, 0.08);
    color: ${(props) => props.$color};
    text-align: center;
`;

const TypeBadge = styled(Body3Medium)<{ $color: string }>`
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 0px;
    border-radius: 9999px;
    background: rgba(64, 108, 197, 0.08);
    color: ${(props) => props.$color};
    text-align: center;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

const SmsButton = styled.button`
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    background-color: ${PrimaryColor.color_primary_normal};
    color: white;
    border: none;

    &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
`;

export default AdminVoucherPaginationTable;
